export default "__VITE_ASSET__DjgpbLIZ__"